import { render } from "./SetupCompany.vue?vue&type=template&id=04d9ec12"
import script from "./SetupCompany.vue?vue&type=script&lang=js"
export * from "./SetupCompany.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__